import React from "react";
import "./PriceCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const PricingCard = ({
  icon = null,
  titleId,
  subtitleId,
  definitionId,
  items,
  isActive = false,
}: any) => {
  return (
    <div className={`pricecard-main-container ${!isActive ? "inactive" : ""}`}>
      <div className="pricecard-check-container">
        {icon && (
          <FontAwesomeIcon
            icon={icon}
            size="2x"
            className="pricecard-plancheck"
          />
        )}
      </div>
      <div className="pricecard-title-container">
        <p className="pricecard-title">
          <FormattedMessage id={titleId} />
        </p>
        {/*<p className="pricecard-subtitle">*/}
        {/*  <FormattedMessage id={subtitleId} />*/}
        {/*</p>*/}
        <p className="pricecard-definition">
          <FormattedMessage id={definitionId} />
        </p>
      </div>
      <div className="pricecard-item-container">
        <ul className="pricecard-items-ul">
          {items.map((itemId: any, index: any) => (
            <li key={index}>
              <FontAwesomeIcon
                className={`pricecard-checkicon ${
                  !isActive ? "inactive-checkicon" : ""
                }`}
                icon={faCheck}
                size="lg"
              />
              <FormattedMessage id={itemId} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PricingCard;
